import { render, staticRenderFns } from "./AffiliatesReferred.vue?vue&type=template&id=e39d1e96&scoped=true"
import script from "./AffiliatesReferred.vue?vue&type=script&lang=js"
export * from "./AffiliatesReferred.vue?vue&type=script&lang=js"
import style0 from "./AffiliatesReferred.vue?vue&type=style&index=0&id=e39d1e96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e39d1e96",
  null
  
)

export default component.exports